<template>
  <div id="vabOnlyOffice"></div>
</template>

<script>

import { getFileType } from "@shared/utils/wayne";
export default {
  name: "VabOnlyOffice",
  props: {
    option: {
      type: Object,
      default: () => {
        return {
            
        };
      },
    },
  },
  data() {
    return {
        key:"",
        user_infos:JSON.parse(localStorage.getItem("zhimingLoginData")),
        docEditor: null,
    };
  },
  watch: {
    option: {
      handler: function (n) {
        this.setEditor(n);
        this.doctype = getFileType(n.fileType);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    try { if (this.docEditor) this.docEditor.destroyEditor() } catch (e) { /* onlyoffice 未就绪时忽略 */ }
  },
  mounted() {
    if (this.option.url) {
      this.setEditor(this.option);
    }
  },
  methods: {
    onRequestSave(e) {
    },
    onDocumentStateChange(e) {
    },
    onCloseCallback() {
    },
    onRequestSaveAs(event) {
    },
    onDownloadAs(event) {
    },
    async setEditor(option) {
      let coursewareIdParam = "";
      if (option.allresult.owner == "个人") {
        coursewareIdParam = `&courseware_id=${option.id}`;
      }
      let callbackUrl = `${this.$store.state.onlyofficeUrl}/console/office/callback?name=${option.title}&edition_id=${JSON.parse(localStorage.getItem("zhimingSemesterId"))}&textbook_id=${JSON.parse(localStorage.getItem("zhimingVersionId"))}&subject_id=${JSON.parse(localStorage.getItem("zhimingSubjectId"))}&chapter_id=${JSON.parse(localStorage.getItem('zhimingPlanData')).chapter_id}&type=${option.allresult.type}&kind=${option.allresult.kind}&file_type=${option.allresult.file_type}&from_id=${this.user_infos.corp_id}&user_id=${this.user_infos.id}&user_name=${this.user_infos.username}&file_from=个人&set_id=${JSON.parse(localStorage.getItem("zhimingSetId"))}${coursewareIdParam}`;
      let editorConfig = {
        "callbackUrl": callbackUrl,
            "lang": "zh-CN",
            "spellcheck": false,
            "mode": "edit",
            "customization": {
              "spellcheck": false,
                "anonymous": { 
                    "request": false,
                    "label": "aaa",
                },
                "forcesave":true
            },
            user: {
                id: String(this.user_infos.id),
                name:this.user_infos.username,
                group: this.user_infos.corp,
            }
        }
         let permissions = {
        "download": false,
        "edit": true,
        "print": false,
        "save": true
    };
    if(option.allresult.type=="学程文件"){
      permissions.download=true
      permissions.print=true
    }

      if (option.fileType === 'pptx') {
        if (option.allresult.owner == "平台") {
          permissions.fillForms = false; // PPT不需要可改为false
          this.key = `${this.user_infos.id}` + 'pptx' + Date.now() + "owner1"
    
          
        } else {
        
          permissions.fillForms = false; // PPT不需要可改为false
          this.key=`${this.user_infos.id}`+'pptx'+Date.now()
      }
    } else if (option.fileType === 'docx') {
        if (option.allresult.owner == "平台") {
          permissions.fillForms = false; // PPT不需要可改为false
          this.key = `${this.user_infos.id}` + 'pptx' + Date.now() + "owner2"
        } else {

          permissions.fillForms = false; // PPT不需要可改为false
          this.key = `${this.user_infos.id}` + 'pptx' + Date.now()
        }
    } else {
      // 其他类型(教学设计md/doc、pdf等)同样需要唯一key, 否则 onlyoffice 报 One or more required parameter is not set
      this.key = `${this.user_infos.id}` + String(option.fileType || 'file') + Date.now()
    }

      let document = {
        title: option.title,  // 修改为PPT文件名
        url: option.url, // 改为PPT文件URL
        fileType: option.fileType,        // 修改文件类型为PPT
        key: this.key,        // 建议为PPT文件设置独立key
        permissions: permissions,
        language: "zh-CN", // 添加文档语言设置
        lang: "zh-CN", // 添加额外语言设置
        regionalSettings: "zh-CN",
spellcheckLocale: "zh-CN"
      }
         this.docEditor = new DocsAPI.DocEditor("vabOnlyOffice",  {
                  type: "desktop",
                  width: "100%",
                  height: "100%",
                  document: document,
                  editorConfig: editorConfig
              });

    },
  },
};
</script>